import { client } from './backend/client'

/* eslint-disable camelcase */
// One listing as `GET /api/lists` answers with it: every field
// `Metalist.HTTP.View.list/1` renders, spelled as the server spells it. Naming
// them all rather than picking out the one field read below is so that the shape
// of the response is written down where it is consumed, and so that a field the
// server adds is visibly absent here rather than arriving untyped. Nothing but
// `name` is projected out below, so nothing but `name` can reach the caller.
interface ListingResponse {
  id: string
  name: string
  active: boolean
  public: boolean
  user_id: string | null
  type: string
  inserted_at: string
  progress: number
  items: unknown[]
}
/* eslint-enable camelcase */

// The signed-in user's own lists, by name.
//
// Names, and nothing else, which is the whole of what the route shows. The server
// sends ids, and an id is what a link needs, so keeping it out of this module's
// return value is what makes "links nowhere" a property of the code rather than of
// the template's restraint -- a template that wanted to link would have nothing to
// link to. The reason it cannot be a link today is in `views/MyLists.vue`: the
// detail view reads the public namespace, and a private listing is not served
// there.
//
// `/lists` and the authenticated client, deliberately. This is the one read of a
// listing in the application that is not browsing: `GET /api/lists` answers with
// the caller's active lists, private included, and it is behind
// `Metalist.AuthPlug`. The public client is the other half of the API and is not
// made authentication-aware to serve this one.
export async function myListingNames (): Promise<string[]> {
  const response = await client.get('/lists')

  return response.data.map((listing: ListingResponse) => listing.name)
}
